/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { SearchSortField, SearchSortOrder } from "~/generated/graphql";
import { SortDirection, SortSelector } from "~/components";

const SELECT_OPTIONS = [
  {
    value: SearchSortField.Cost,
    label: "Monthly Costs",
  },
  {
    value: SearchSortField.ProviderId,
    label: "Resource name",
  },
  {
    value: SearchSortField.Type,
    label: "Resource type",
  },
];

type Props = {
  sortField: string;
  sortDirection: SearchSortOrder;
  onSortSelect: (value: SearchSortField) => void;
  onSortOrderChange: (value: SortDirection) => void;
};

export function PodSort({
  sortField,
  sortDirection,
  onSortSelect,
  onSortOrderChange,
}: Props) {
  return (
    <SortSelector
      options={SELECT_OPTIONS}
      value={sortField}
      direction={
        sortDirection === SearchSortOrder.Asc
          ? SortDirection.Ascending
          : SortDirection.Descending
      }
      onSelect={(filter) => onSortSelect(filter as SearchSortField)}
      onSortChange={onSortOrderChange}
    />
  );
}
